import { render, staticRenderFns } from "./register.vue?vue&type=template&id=5e76e5fa&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=5e76e5fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/metadata.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Frunner%2F_work%2FCoreWeb%2FCoreWeb%2Fpages%2Faccount%2Fregister.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./register.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports